import React, { useEffect, useState } from 'react';
import { locales } from '../../../../translations/locales';

const BtnStatus = (props) => {
    const { listStatus, code, text, outdated, locale } = props;
    const [textDisplay, setTextDisplay] = useState(text);
    const status = listStatus.find((status) => Number(status.code) === Number(code)) || { name: 'Error', backgroundColor: 'gray', textColor: 'black' };

    useEffect(() => {
        if (outdated) {
            const interval = setInterval(() => {
                setTextDisplay(textDisplay === locales[locale].sgo.deadlineExceeded ? text : locales[locale].sgo.deadlineExceeded);
            }, 1000);
            return () => clearInterval(interval);
        }
    }, [textDisplay, outdated]);

    return (
        <button
            className={`btn btn-sm btn-status m-1 ${outdated ? 'delaiDepasse' : ''}`}
            style={{
                background: status.backgroundColor,
                color: status.textColor,
            }}
            data-text={textDisplay}
        >
            {!outdated && (text || status.name)}
        </button>
    );
};

export default BtnStatus;
